import React, { useRef, useState } from 'react'
import "./LandingPage3.css"
import { Form } from '../../../../form/Form';
import { useEffect } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import StateArray from '../../../../assets/json/state';
import { resolvefunction } from '../../../../helper/helperFunctions';
import { fetchCalenderEvents } from '../../../Calendar/calenderReducer';
import { setLeadinfo } from '../../../login/loginReducer';
import store from '../../../../store';
import { Box } from '@mui/system';
import { LinearProgress } from '@mui/material';
import AnalysisImplementation from './AnalysisImplementation/AnalysisImplementation';
import AuditAnalyze from './AuditAnalaize/AuditAnalyze';
import { addconverstiondata, addlandingpagetwodatalead, clearlandingpagesubmittionstate, getlandingpagedata, getlandingpageoneuserdata, updateStages, updateTags } from '../LandingpageReducer';
import { setSnackbar } from '../../../Layout/layoutReducer';


function LandingPage3() {

  const navigate = useNavigate();
  const dispatch = useDispatch();

  const [locationArry, setLocationArry] = useState([]);
  // const [reqbodyforjobcategory, setreqbodyforjobcategory] = useState({});

  // const [submissionState, setSubmissionState] = useState(0);
  const [loading, setloading] = useState(false);

  const formInputData = useSelector((state) =>
    state.formSlice.formData.userForm3 ? state.formSlice.formData.userForm3 : null
  );
  const submissionState = useSelector((state) =>
    state.formSlice.formSubmissionState.userForm3 ? state.formSlice.formSubmissionState.userForm3 : null
  );

  const userData = useSelector(state => (state.LandingpagefontReducer?.landingpageoneuserdata && Object.keys(state.LandingpagefontReducer?.landingpageoneuserdata).length > 0) ? state.LandingpagefontReducer.landingpageoneuserdata : {});

  const addedData = useSelector(state => (state.LandingpagefontReducer?.addedinfo && Object.keys(state.LandingpagefontReducer?.addedinfo).length > 0) ? state.LandingpagefontReducer.addedinfo : {});
  const landingpageformsubmitionstate = useSelector(state => (state.LandingpagefontReducer?.landingpagesubmittionstate) ? state.LandingpagefontReducer.landingpagesubmittionstate : 0)
  // console.log("loading", loading)
  const ipinfo = useSelector(state => (state.loginSlice?.ipInfo && Object.keys(state.loginSlice.ipInfo).length > 0) ? state.loginSlice.ipInfo : null)
  const [conversionapicall, setConversionapicall] = useState(false);
  const { uniquename } = useParams();

  let currTime = new Date().getTime();
  let dayAfterTomorrow = (currTime + (48 * 3600 * 1000));
  const [slotListBody, setSlotListBody] = useState({
    "condition": {
      "limit": 10,
      "skip": 0
    },
    "sort": {
      "field": "start_datetime_unix",
      "type": "desc"
    },
    "searchcondition": {
      // userid: getcookies.userInfo?._id,
      "start_datetime_unix": {
        "$gte": dayAfterTomorrow
      }
    }
    // "slot_creation_type": props.type === 'np' ? 2 : 1
  })
  let reqbodyforjobcategory = {}
  if (typeof uniquename != 'undefined') {
    reqbodyforjobcategory = {
      "uniquename": uniquename,
    }
  }
  else {
    reqbodyforjobcategory = {
      "page_slug": process.env.REACT_APP_LANDINGPAGE_SLUG,
    }
  }

  useEffect(() => {
    if (userData && ipinfo) {
      console.log("userData", userData);
      let body = {
        // "campaign_id":userData.campaign_id,
        "associated_program": userData.associated_program,
        "landing_page_id": userData.landing_page_id,
        "landing_page_slug": userData.landing_page_slug,
        // "campaign_added_by":userData.user_id,
        // "hiring_manager":userData.hm_id,
        "ipInfo": ipinfo
      }
      if (userData.campaign_id) body['campaign_id'] = userData.campaign_id;
      if (userData.user_id) body['campaign_added_by'] = userData.user_id;
      if (userData.hm_id) body['hiring_manager'] = userData.hm_id;

      console.log("+++++++++++++++++++", body);
      if (body && body.landing_page_id && !conversionapicall) {
        dispatch(addconverstiondata(body))
        setConversionapicall(true)

      }

      //    let bodyc= Object.keys(body).forEach(key => body[key] === undefined && delete body[key])
      //    console.log("bodyc",bodyc);
    }

  }, [JSON.stringify(ipinfo), JSON.stringify(userData)])
  useEffect(() => {
    if (uniquename) {

      store.dispatch(getlandingpageoneuserdata(reqbodyforjobcategory));
    }
    else {

      store.dispatch(getlandingpagedata(reqbodyforjobcategory));
    }
  }, [])

  useEffect(() => {
    let Newarr = [];
    if (StateArray && StateArray.length > 0) {
      for (let i in StateArray) {
        Newarr.push({ val: StateArray[i].name, name: StateArray[i].name });
      }
      setLocationArry(Newarr);
    }
  }, []);

  useEffect(() => {
    if (submissionState && submissionState === 4) {
      addapicall(formInputData);
    }
  }, [submissionState]);

  const addapicall = async (val) => {
    console.log("dataacccccccccccccccccccccccc", val);

    val = { ...val }
    let body = {
      "firstname": val.firstname,
      "lastname": val.lastname,
      "email": val.email,
      "phone": val.phone,
      "city": val.city,
      "state": val.state,
      // "zip": val.zip,
      // "address": val.address,
      "website": val.website,
      "employeeSize": val.employeeSize,
      "years_in_business": val.years_in_business,
      "interest_services": val.interest_services,
      "campaign_id": userData.campaign_id,
      "associated_program": userData.associated_program,
      "page_id": userData.landing_page_id,
      "page_slug": userData.landing_page_slug,
      "user_id": userData.user_id,
      "hiring_manager": userData.hm_id,
      "createdon_datetime": new Date().getTime(),
      "status": 0,
      "rep_id": userData.rep_id,
      "aer_id": userData.aer_id,
      "associated_bdd": userData.associated_bdd,
      "added_type": 'landingpage',
      "calender_access_form_submit_time": userData.calendar_access ? 2 : 1


      // is_lead: true,


    }
    console.log("");

    if (Object.keys(body).length > 0) {
      console.log("body-----", body);

      setloading(true)
      await store.dispatch(addlandingpagetwodatalead(body));
      // setActive(false)
      setloading(false)
      // if(){

      // }
    }



  };

  useEffect(() => {
    console.log("userData", landingpageformsubmitionstate, addedData);

    //   resolvefunction(navigate, `/calendar/${addedData._id}`, [
    //     fetchCalenderEvents(slotListBody),
    //   ]);
    dispatch(setLeadinfo(addedData));
    store.dispatch(clearlandingpagesubmittionstate())


    const data = {
      stage_slug: '5QH6nS8FXNawY',
      added_by: addedData._id,
      added_for: addedData._id,
      is_delete: 0,
      status: 1
    }
    console.log("data===========================>", data)
    // return
    dispatch(updateStages(data));


    const tagdata = {
      added_by: addedData._id,
      added_for: addedData._id,
      key: "Wnv14tRS9FlmV",
      label: "hm-policiesandcompliance-signed-success",
      is_delete: 0,
      status: 1
    }
    console.log("tagdata===========================>", tagdata)
    // return
    dispatch(updateTags(tagdata));

    if (landingpageformsubmitionstate && landingpageformsubmitionstate == 2) {
      dispatch(setSnackbar({ open: true, message: "Thank you for Submitting!", status: 'success' }))
      if (userData.calendar_access && userData.calendar_access == 1) {
        if (userData?.associated_bdd && userData.associated_bdd[0]) {
          slotListBody.searchcondition['userid'] = userData.associated_bdd[0]
          slotListBody['organiser_role'] = 'bdd'
        }
        slotListBody['_id'] = addedData._id;
        resolvefunction(navigate, `/calendar/${addedData._id}/bdd/${userData.associated_bdd[0]}`, [
          fetchCalenderEvents(slotListBody),
        ]);
      }
      else {
        navigate(`/thankyou`);
      }


    }
    //  return () => {
    //   store.dispatch(clearlandingpagesubmittionstate())
    // //   store.dispatch(resetresolvenew('/:uniquename'))
    // }

  }, [landingpageformsubmitionstate])

  const formDataL2 = {
    id: 'userForm3',
    formtype: "add",
    // api_url: process.env.REACT_APP_API_URL,
    // endPoint: "lead-manage/add-update-intake-form",
    // endPointBodyWrapper: "data",
    // urlPathOnSuccessfulFormSubmission: "/calendar",
    msgOnFailedFormSubmission: "Something Went Wrong",
    formWrapperClass: "formWrapperClass",// Can be undefined default will be formCls
    formInlineCLass: "userForm", // Can be undefined default will be formInline
    formButtonClass: "l2submitbtnsection",
    submitBtnName: "Submit",
    // submitBtnStartIcon: 'image_search_icon',
    // submitBtnEndIcon: 'search_icon',
    resetBtnName: "Reset",
    formAdditionalSubmissionData: {
      type: "admin",
      status: "active",
    },
    fields: [
      //////////////////////////////////// Text Input ///////////////////////////////
      {
        id: 0,
        // heading: "Full Name",
        label: "First Name",
        name: "firstname",
        className: 'formfild',
        type: "text",
        rules: { required: true },
        errorMessage: {
          required: "This Field is Required",
          custom: "Value is Invalid"
        },
      },
      {
        id: 1,
        // heading: "Full Name",
        label: "Last Name",
        name: "lastname",
        className: 'formfild',
        type: "text",
        rules: { required: true },
        errorMessage: {
          required: "This Field is Required",
          custom: "Value is Invalid"
        },
      },
      {
        id: 3,
        // heading: "Full Name",
        label: "Phone No",
        name: "phone",
        className: 'formfild',
        type: "text",
        inputType: "phone",
        rules: { required: true, minLength: 10 },
        errorMessage: {
          required: "This Field is Required",
          custom: "Value is Invalid"
        },

      },
      {
        id: 2,
        // heading: "Full Name",
        label: "Email",
        name: "email",
        className: 'formfild',
        type: "text",
        inputType: "email",
        rules: { required: true },
        errorMessage: {
          required: "This Field is Required",
          custom: "Value is Invalid"
        },

      },
      {
        id: 4,
        // heading: "Full Name",
        label: "Website",
        name: "website",
        className: 'formfild',
        type: "text",
        inputType: "website",
        rules: { required: true },
        errorMessage: {
          required: "This Field is Required",
          custom: "Value is Invalid"
        },

      },

      // {
      //     id: 4,
      //     heading: "Full Name",
      //     label: "Address",
      //     name: "address",
      //     className: 'formfild',
      //     type: "text",
      //     inputType: "text",/////////////// If not mentioned default will be text //////////////
      //     rules: { required: true },
      //     errorMessage: {
      //         required: "This Field is Required",
      //         custom: "Value is Invalid"
      //     },
      // },


      {
        id: 6,
        // heading: "Full Name",
        label: "State",
        name: "state",
        className: 'formfild state',
        type: "select",
        // other: true,
        values: locationArry,
        rules: { required: true },
        errorMessage: {
          required: "This Field is Required",
          custom: "Value is Invalid"
        },
        defaultValue: "",
      },

      {
        id: 5,
        // heading: "Full Name",
        label: "City",
        name: "city",
        className: 'formfild',
        type: "text",
        rules: { required: true },
        errorMessage: {
          required: "This Field is Required",
          custom: "Value is Invalid"
        },

      },

      {
        id: 7,
        // heading: "Full Name",
        label: "Employee Size",
        name: "employeeSize",
        className: 'formfild',
        type: "text",
        // inputType: "number",
        rules: { required: true },
        errorMessage: {
          required: "This Field is Required",
          maxLength: "MaxLength length 20 allowed",
          validate: "Lastnameeeeeeee is not valid",
          custom: "Value is Invalid"
        },

      },

      {
        id: 8,
        // heading: "Full Name",
        label: "Years in Business",
        name: "years_in_business",
        className: 'formfild',
        type: "text",
        rules: { required: true },
        errorMessage: {
          required: "This Field is Required",
          custom: "Value is Invalid"
        },

      },

      {
        id: 16,
        type: "html",
        className: "form_text",
        value: "<p>Check Service interests</p>"
      },
      {
        id: 10,
        // heading: "Married",
        name: "interest_services",
        className: 'form_radio',
        values: [{ key: 'All', val: 'All' }, { key: 'Utilities', val: 'Utilities' }, { key: 'Workers Comp.', val: 'Workers Comp.' }, { key: 'Credit Card Processing', val: 'Credit Card Processing' }, { key: 'Wireless', val: 'Wireless' }, { key: 'Laundry & Linen', val: 'Laundry & Linen' }],
        type: 'radio',
        hint: 'Yes/No',
        rules: { required: true },
        errorMessage: {
          required: "This Field is Required",
          custom: "Value is Invalid"
        },
        // defaultValue: "No"
      },

    ]

  };

  // store.subscribe(() => {
  //     const storeData = store.getState();
  //     if (storeData && storeData.formSlice && storeData.formSlice.formSubmissionState && storeData.formSlice.formSubmissionState.userForm2) {
  //         setSubmissionState(storeData.formSlice.formSubmissionState.userForm2);
  //     }
  //     // console.log(setSubmissionState, "setSubmissionState")
  //     // console.log("landing store", storeData)
  // })

  return (
    <>
      <div className='landing_page3_bannerblock LP3_BB_new_for_responsive'>
        <div className='landing-container'>
          <div className='landing-col-container'>
            <div className='landing-banner-left'>
              <div className='lpage_logowrapper'>
                <img src='https://all-frontend-assets.s3.amazonaws.com/aspireLeadFire/landingpage3/l_page3_logo.png' />
              </div>
              <div className='lpage_banner_titlewrapper'>
                <h1>
                  <span>WE GET YOU REFUNDS AND </span>
                </h1>
                <h1>
                  <span>ONGOING SAVINGS,</span> OR YOU
                </h1>
                <h1>PAY US NOTHING!</h1>
              </div>
              {process.env.REACT_APP_LANDINGPAGE_SLUG == 'DSqUHfhYLszrA' ? <div className='lpage_banner_main_video_wrapper'> <div className='lpage_banner_sub_video'>
                {/* <img src='https://all-frontend-assets.s3.amazonaws.com/aspireLeadFire/landingpage3/landing3_video_img.webp' /> */}

                <iframe
                  width=""
                  height=""
                  src="https://player.vimeo.com/video/775893777?color&autopause=0&loop=0&muted=0&title=0&portrait=0&byline=0&h=32cd0ccabc#t="
                  title="YouTube video player"
                  frameborder="0"
                  allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                  allowfullscreen
                ></iframe>
              </div></div> : <div className='lpage_banner_sub_wrapper'>
                <h2>
                  Qualify for immediate high-dollar refunds and ongoing savings from services you are
                  already using! Many of our clients get back as much as six figures after a short discussion with our consultants!
                </h2>
                <div className='lpage_banner_textwrapper'>
                  <h4>
                    LOOK BELOW FOR EXAMPLES OF WHAT WE HAVE DONE FOR OUR CUSTOMERS!
                  </h4>
                </div>
              </div>}

              <div className='lpage_arrow_wrapper'>
                <h2>Please fill out the form and schedule <br />
                  to talk with our experts!</h2>
              </div>


            </div>
            <div className='landing-banner-right landingThree'>
              <div className='formwrapper'>
                <div className='form_title_wrapper'>
                  <h2>
                    <span>SPEAK WITH AN ASPIRE </span>
                    <span>EXPENSE REDUCTION AND </span>
                    <span>REFUND EXPERT RIGHT AWAY </span>
                  </h2>
                </div>
                <div className='form_style'>
                  <Form formData={formDataL2} />

                  {loading ? (<Box className="loaderProgress" sx={{ width: "100%", mt: "0px" }}><LinearProgress /></Box>) : (null)}

                </div>

              </div>
            </div>
          </div>
        </div>
      </div>

      <div className='landing_page3_block2'>
        <div className='landing-container'>
          <div className='landing_page3_block2_subwrapper'>
            <div className='textwrapper'>
              <h2>What Aspire Expense Reduction has to offer?</h2>
              <p>
                <span> Aspire Expense Reduction </span>
                specializes in helping companies reduce their controllable operating expenses by saving companies money and time at no cost to the companies.
              </p>
            </div>
            <div className='landing_page3_listwrapper'>
              <h2>Aspire Expense Reduction Delivers:</h2>
              <div className='landing_page3_list'>
                <p>Typical Expense Reductions of <span> 10% </span> to <span> 50% </span> </p>
                <p>Fast Results saving Time, Money and Frustration</p>
                <p>Expert Teams with  <span> 20+ Years </span> of Experience</p>
                <p>Savings without changing your current vendors</p>
                <p> Minimal resource time required from your team</p>
                <p>Contingency-based / no up-front costs</p>
              </div>
            </div>
          </div>
        </div>
      </div>


      <div className='landing_page3_block3'>
        <div className='landing-container'>
          <div className='landing_page3_block3_subwrapper'>
            <div className='landing_page3_block3_colcontainer'>
              <div className='block3-col'>
                <div className='colnumber'>1</div>
                <div className='block3-col-text'>
                  <h3>Analyze past billing to <br />
                    Identify Savings</h3>
                  <p>Our deep historical forensic audit
                    looks for errors and overbillings
                    to generate refunds & credits</p>
                </div>
                <div className='colicon'><img src="https://all-frontend-assets.s3.amazonaws.com/aspireLeadFire/landingpage3/l_page3_block3_icon1.png" /></div>
              </div>
              <div className='block3-col'>
                <div className='colnumber'>2</div>
                <div className='block3-col-text'>
                  <h3>Optimize Pricing to <br />
                    Capture Savings</h3>
                  <p>We benchmark present pricing
                    within the current contract to identify
                    price & rate reduction opportunities</p>
                </div>
                <div className='colicon'><img src="https://all-frontend-assets.s3.amazonaws.com/aspireLeadFire/landingpage3/l_page3_block3_icon2.png" /></div>
              </div>
              <div className='block3-col'>
                <div className='colnumber'>3</div>
                <div className='block3-col-text'>
                  <h3>Protect & Monitor to Secure <br />
                    & Ensure Savings</h3>
                  <p>Monitor & protect against future
                    pricing errors, fees, erroneous
                    charges, and random rate increases</p>
                </div>
                <div className='colicon'><img src="https://all-frontend-assets.s3.amazonaws.com/aspireLeadFire/landingpage3/l_page3_block3_icon3.png" /></div>
              </div>
            </div>

          </div>
        </div>
      </div>

      <div className='landing_page3_block4'>
        <div className='landing-container'>
          <div className='landing_page3_block4_subwrapper'>
            <div className='title_wrapper'>
              <h1>Past Client Utility Bill Savings</h1>
            </div>
            <div className='landing_page3_block4_colcontainer'>
              <div className='block4_col'>
                <h4>Delta Dental </h4>
                <h2>$450,000 </h2>
                <p>In Refunds</p>
              </div>
              <div className='block4_col'>
                <h4>Mclaren
                  Healthcare</h4>
                <h2>$250,000</h2>
                <p>Annual Savings</p>
              </div>
              <div className='block4_col'>
                <h4>FORD FIELD / DETROIT
                  LIONS</h4>
                <h2>$150,000</h2>
                <p>Gas & Electric Savings</p>
              </div>
              <div className='block4_col'>
                <h4>EASTERN
                  MICHIGAN UNIV</h4>
                <h2>$350,000</h2>
                <p>Annual Savings</p>
              </div>
              <div className='block4_col'>
                <h4>SHAPE
                  CORPORATION</h4>
                <h2>$150,000</h2>
                <p>Multiple Locations</p>
              </div>
              <div className='block4_col'>
                <h4>THE HYLANT
                  GROUP</h4>
                <h2>$160,000</h2>
                <p> In Refunds</p>
              </div>
              <div className='block4_col'>
                <h4>MARWOOD
                  MANOR</h4>
                <h2>$115,000</h2>
                <p>Savings & Refunds</p>
              </div>
              <div className='block4_col'>
                <h4>CHESAPEAKE
                  SPICE</h4>
                <h2>$100,000+</h2>
                <p>Savings & Refunds</p>
              </div>
            </div>
            <div className='landing_page3_block4_sub_textwrapper'>
              <h3>Total Utility Results for one of our Clients:</h3>
              <h1>Refunds : $350,000</h1>
              <p>Annual Electric Savings: $150,000</p>
              <p>Annual Water Savings: $11,000</p>
              <p>Annual Natural Gas Savings: $140,000</p>
            </div>
          </div>
        </div>
      </div>

      <div className='landing_page3_block5'>
        <div className='landing-container'>
          <div className='landing_page3_block5_subwrapper'>
            <div className='landing_page3_block5_colcontainer'>
              <div className='block5-col'>
                <div className='block5-col-subwrapper'>
                  <div className='block5-col-subwrapper1'>
                    <div className='block5-col-subwrapper2'>
                      <h2>
                        <span>ASPIRE Trucking </span>
                        <span>Company Customer </span>
                        <span>Example:</span>
                      </h2>
                      <p>Reduced the
                        company’s experience
                        rating by <span>10%</span> </p>
                      <div className='borderdiv'></div>
                      <p>Company received
                        a refund check
                        of <span>$42,000</span></p>
                    </div>
                  </div>
                </div>
              </div>
              <div className='block5-col'>
                <div className='block5-col-subwrapper'>
                  <div className='block5-col-subwrapper1'>
                    <div className='block5-col-subwrapper2'>
                      <h2>
                        <span>Wireless</span>
                        <span>Service Reduction </span>
                        <span>Examples:</span>
                      </h2>
                      <p>
                        AT&T customer was
                        reduced from
                        <span>$8,800 </span> down to $6,000/month
                        or 32%
                      </p>
                      <div className='borderdiv'></div>
                      <p>
                        Verizon customer was reduced from
                        <span>$5,200 </span> down to $2,000/month
                        or 61%
                      </p>
                    </div>
                  </div>
                </div>
              </div>
              <div className='block5-col'>
                <div className='block5-col-subwrapper'>
                  <div className='block5-col-subwrapper1'>
                    <div className='block5-col-subwrapper2'>
                      <h2>
                        <span>ASPIRE Auto </span>
                        <span>Dealership Customer </span>
                        <span>Example:</span>
                      </h2>
                      <p>
                        Refund of
                        <span>$12,000</span>  from
                        audit due to billings
                        outside of the scope of
                        the contract
                      </p>
                      <div className='borderdiv'></div>
                      <p>
                        Renegotiated contract totaling
                        <span>45% </span> in savings, annual savings of $63,000, and a $315,000 savings
                        over 5-years.
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <img src='https://all-frontend-assets.s3.amazonaws.com/aspireLeadFire/landingpage3/landing_page3_block5_image1.png' className='abimage' />
          </div>
        </div>
      </div>
      <div className="landing_page3_block5-1">
        <div className='landing-container'>
          <div className="landing_page3_block5-1_block_wrapper">
            <div className="LP3_b5-1_top_box">
              <div className="LP3_b5-1_top_box_headder"><h1>Aspire expense reduction <span>5X grid</span></h1></div>
              <div className="LP3_b5-1_top_box_lower">
                <div className="LP3_b5-1_top_box_lower_color1">
                  <div className="LP3_b5-1_tb_lower_colorbox1 LP_b5-1_size"></div>
                  <p>Refund + rate Savings + Rate Protection</p>
                </div>
                <div className="LP3_b5-1_top_box_lower_color1">
                  <div className="LP3_b5-1_tb_lower_colorbox2 LP_b5-1_size"></div>
                  <p>Rate Savings + Rate Protection</p>
                </div>
                <div className="LP3_b5-1_top_box_lower_color1">
                  <div className="LP3_b5-1_tb_lower_colorbox3 LP_b5-1_size"></div>
                  <p>Refund + Rate Savings</p>
                </div>
              </div>
            </div>
            <div class="table_main_wrapper"><div class="table_heading_row_wrapper"><div class="table_row_wrapper"><p><span><label>Service</label></span></p><p><span><label>Minimum to Qualify</label></span></p><p><span><label>Needed For Audit</label></span></p><p><span><label>Audit Time</label></span></p><p><span><label>Recovery Goal</label></span></p><p><span><label>Savings Range</label></span></p><p><span><label>Average Savings</label></span></p><p><span><label>Success Rate</label></span></p></div></div><div class="table_desc_row_wrapper"><div class="table_row_wrapper table_common_font"><p><span data-label="Service"><label> Laundry &amp; Linen</label></span></p><p><span data-label="Minimum to Qualify"><label>$100,000/yr. across all entities</label></span></p><p><span data-label="Needed For Audit"><label>4-weeks of Invoices, Current contract, Signed Agreement + LOA</label></span></p><p><span data-label="Audit Time"><label>2 Weeks</label></span></p><p><span data-label="Recovery Goal"><label class="green_bg_color">Refund + Rate Savings + Rate Protect</label></span></p><p><span data-label="Savings Range"><label>30 - 50%</label></span></p><p><span data-label="Average Savings"><label>35%</label></span></p><p><span data-label="Success Rate"><label>95+%</label></span></p></div><div class="table_row_wrapper table_common_font"><p><span data-label="Service"><label>Wireless</label></span></p><p><span data-label="Minimum to Qualify"><label>$24k year across all entities</label></span></p><p><span data-label="Needed For Audit"><label>3 months of statements, LOA</label></span></p><p><span data-label="Audit Time"><label>2 Weeks</label></span></p><p><span data-label="Recovery Goal"><label class="green_bg_color">Rate Savings + Rate Protect</label></span></p><p><span data-label="Savings Range"><label>15- 50%</label></span></p><p><span data-label="Average Savings"><label>25%</label></span></p><p><span data-label="Success Rate"><label>95%</label></span></p></div><div class="table_row_wrapper table_common_font"><p><span data-label="Service"><label>Workers Comp</label></span></p><p><span data-label="Minimum to Qualify"><label>$40k year across all entities</label></span></p><p><span data-label="Needed For Audit"><label>Signed Agreement, LOA, Client Interview Checklist</label></span></p><p><span data-label="Audit Time"><label>2 Weeks</label></span></p><p><span data-label="Recovery Goal"><label class="orange_bg_color">Refund back as much as 7 yrs. + rate savings in somncases</label></span></p><p><span data-label="Savings Range"><label>5 - 15% per yr. payments refund </label></span></p><p><span data-label="Average Savings"><label>10% per each yr. payment refund</label></span></p><p><span data-label="Success Rate"><label>70%</label></span></p></div><div class="table_row_wrapper table_common_font"><p><span data-label="Service"><label>Credit Card Processing</label></span></p><p><span data-label="Minimum to Qualify"><label>$300,000/yr. in c. c. processing</label></span></p><p><span data-label="Needed For Audit"><label>3 months of statements + Letter of Authorization</label></span></p><p><span data-label="Audit Time"><label>1 Weeks</label></span></p><p><span data-label="Recovery Goal"><label class="darkr_grey_bgcolor">Rate Savings + Rate Product</label></span></p><p><span data-label="Savings Range"><label>5 - 45%</label></span></p><p><span data-label="Average Savings"><label>28%</label></span></p><p><span data-label="Success Rate"><label>90%</label></span></p></div><div class="table_row_wrapper table_common_font"><p><span data-label="Service"><label>Utilities</label></span></p><p><span data-label="Minimum to Qualify"><label>$60k yr. per each location </label></span></p><p><span data-label="Needed For Audit"><label>1 mo. of invoices or Online Access to energy bill</label></span></p><p><span data-label="Audit Time"><label>2-4 Weeks</label></span></p><p><span data-label="Recovery Goal"><label class="green_bg_color">Refund + Rate Savings + Rate Protect</label></span></p><p><span data-label="Savings Range"><label>5 - 20%</label></span></p><p><span data-label="Average Savings"><label>10%</label></span></p><p><span data-label="Success Rate"><label>90%</label></span></p></div></div></div>
            {/* <div className="LP3_b5-1_center_box">
             <div className="LP3_b5-1_center_box_headding_wrapper"> 
              <div className="LP3_b5-1_table_row_wrapper">
                <p><span><label>Service</label></span></p>
                <p><span><label>Minimum to Qualify</label></span></p>
                <p><span><label>Needed For Audit</label></span></p>
                <p><span><label>Audit Time</label></span></p>
                <p><span><label>Recovery Goal</label></span></p>
                <p><span><label>Savings Range</label></span></p>
                <p><span><label>Average Savings</label></span></p>
                <p><span><label>Success Rate</label></span></p>
              </div>
             </div>
             <div className="LP3_b5-1_center_box_describtion_wrapper">
                <div className="LP3_b5-1_table_row_wrapper">
                <p><span data-lable="Service" ><label>Laundry & Linen</label></span></p>
                <p><span data-lable="Minimum to Qualify" ><label>$100,000/yr. across all entities</label></span></p>
                <p><span data-lable="Needed For Audit" ><label>4-weeks of Invoices, Current contract, Signed Agreement + LOA</label></span></p>
                <p><span data-lable="Audit Time" ><label>2 Weeks</label></span></p>
                <p><span data-lable="Recovery Goal" ><label>Refund + Rate Savings + Rate Protect</label></span></p>
                <p><span data-lable="Savings Range" ><label>30 - 50%</label></span></p>
                <p><span data-lable="Average Savings" ><label>35%</label></span></p>
                <p><span data-lable="Success Rate" ><label>95+%</label></span></p>
                </div>
                <div className="LP3_b5-1_table_row_wrapper">
                <p><span data-lable="Service" ><label>Wireless</label></span></p>
                <p><span data-lable="Minimum to Qualify" ><label>$24k year across all entities</label></span></p>
                <p><span data-lable="Needed For Audit" ><label>3 months of statements, LOA</label></span></p>
                <p><span data-lable="Audit Time" ><label>2 Weeks</label></span></p>
                <p><span data-lable="Recovery Goal" ><label>Rate Savings + Rate Protect</label></span></p>
                <p><span data-lable="Savings Range" ><label>15 - 50%</label></span></p>
                <p><span data-lable="Average Savings" ><label>25%</label></span></p>
                <p><span data-lable="Success Rate" ><label>95%</label></span></p>
                </div>
                <div className="LP3_b5-1_table_row_wrapper">
                <p><span data-lable="Service" ><label>Workers Comp</label></span></p>
                <p><span data-lable="Minimum to Qualify" ><label>$40k year across all entities</label></span></p>
                <p><span data-lable="Needed For Audit" ><label>Signed Agreement, LOA, Client Interview Checklist</label></span></p>
                <p><span data-lable="Audit Time" ><label>2 Weeks</label></span></p>
                <p><span data-lable="Recovery Goal" ><label>Refund back as much as 7 yrs. + rate savings in somncases</label></span></p>
                <p><span data-lable="Savings Range" ><label>5 - 15% per yr. payments refund </label></span></p>
                <p><span data-lable="Average Savings" ><label>10% per each yr. payment refund</label></span></p>
                <p><span data-lable="Success Rate" ><label>70%</label></span></p>
                </div>
                <div className="LP3_b5-1_table_row_wrapper">
                <p><span data-lable="Service" ><label>Credit Card Processing</label></span></p>
                <p><span data-lable="Minimum to Qualify" ><label>$300,000/yr. in  c. c. processing</label></span></p>
                <p><span data-lable="Needed For Audit" ><label>3 months of statements + Letter of Authorization</label></span></p>
                <p><span data-lable="Audit Time" ><label>1 Weeks</label></span></p>
                <p><span data-lable="Recovery Goal" ><label>Rate Savings + Rate Product</label></span></p>
                <p><span data-lable="Savings Range" ><label>5 - 45%</label></span></p>
                <p><span data-lable="Average Savings" ><label>28%</label></span></p>
                <p><span data-lable="Success Rate" ><label>90%</label></span></p>
                </div>
                <div className="LP3_b5-1_table_row_wrapper">
                <p><span data-lable="Service" ><label>Utilities</label></span></p>
                <p><span data-lable="Minimum to Qualify" ><label>$60k yr. per each location </label></span></p>
                <p><span data-lable="Needed For Audit" ><label>1 mo. of invoices or Online Access to energy bill</label></span></p>
                <p><span data-lable="Audit Time" ><label>2-4Weeks</label></span></p>
                <p><span data-lable="Recovery Goal" ><label>Refund + Rate Savings + Rate Protect</label></span></p>
                <p><span data-lable="Savings Range" ><label>5 - 20%</label></span></p>
                <p><span data-lable="Average Savings" ><label>10%</label></span></p>
                <p><span data-lable="Success Rate" ><label>90%</label></span></p>
                </div>
              </div>
            </div> */}
            <div className="LP3_b5-1_bottom_box">
              <h1>All 5 of these Expense Categories are 100% Contingency based…NO SAVINGS=NO FEE = NO RISK
              </h1>
            </div>
          </div>
        </div>
      </div>







      <div className='landing_page3_block6'>
        <div className='landing-container'>
          <div className='landing_page3_block6_subwrapper'>
            <div className='textwrapper'>
              <h2>The RateGuard program: Analyze, Optimize, Protect</h2>
              <p>Reduce payment processing expenses. Protect against future rate increases.</p>
              <h4>The RateGuard program manages the complex payment processing fees on your behalf, ensuring your rates are optimized and protected from future rate increases.</h4>
            </div>
            <div className='landing_page3_listwrapper'>
              <p>No switching payment processors.</p>
              <p> No effort on your part.</p>
              <p>Fees contingent on savings</p>
              <p>Zero risk.</p>
              <p>Average merchant savings </p>
            </div>
            <img src='https://all-frontend-assets.s3.amazonaws.com/aspireLeadFire/landingpage3/landing_page3_block6_image1.1..webp' className='abimage' />
          </div>
        </div>
      </div>



      <div className='landing_page3_block7'>
        <div className='landing-container'>
          <div className='landing_page3_block7_subwrapper'>
            <div className='landing_page3_block7_colcontainer'>
              <div className='block7-col'>
                <h3>Analyze</h3>
                <img src='https://all-frontend-assets.s3.amazonaws.com/aspireLeadFire/landingpage3/landing_page3_block7_icon1.png' />
                <p>The RateGuard savings analysis audits your merchant account statement against thousands of interchange and assessment fees to uncover overbilling and hidden charges. Your statement data is analyzed and benchmarked against optimal pricing available with your current payment processor, providing a clear view of potential program savings.</p>
                <h4>Identify Savings</h4>
              </div>
              <div className='block7-col'>
                <h3>Optimize</h3>
                <img src='https://all-frontend-assets.s3.amazonaws.com/aspireLeadFire/landingpage3/landing_page3_block7_icon2.png' />
                <p>Enrolling in the RateGuard program will optimize your rates with your current payment processor, ensuring your merchant account is configured correctly to take advantage of the lowest payment processing rates. The process is fast and there’s no changing payment processors or the manner in which credit cards are processed.</p>
                <h4>Capture Savings</h4>
              </div>
              <div className='block7-col'>
                <h3>Protect</h3>
                <img src='https://all-frontend-assets.s3.amazonaws.com/aspireLeadFire/landingpage3/landing_page3_block7_icon3.png' />
                <p>After your payment processing rates are optimized, they need to be protected against future rate increases. When your payment processor attempts to increase your rates. RateGuard will protect you. Each month you will receive a report showing realized savings from the RateGuard program, along with trending payment processing data.</p>
                <h4>Secure Savings</h4>
              </div>
            </div>
            <div className='landing_page3_block7_subblock2'>
              <div className='landing_page3_block7_list'>
                <h4>1</h4>
                <p>How much savings is available with your payment processor? With the RateGuard Savings Analysis, we can tell you exactly how much you’ll save every year - without changing your payment processor. There’s no cost or obligation for the RateGuard Savings Analysis.</p>
              </div>
              <div className='landing_page3_block7_list'>
                <h4>2</h4>
                <p>Once we’ve identified the savings opportunity, enroll in RateGuard to capture the savings and protect your rates against future increases.
                  There’s no risk or effort from you and no changes to your payment processor.</p>
              </div>
            </div>
            <div className='textwrapper'>
              <p>The RateGuard program works directly with your current payment processor, eliminating the headache of deciphering complex
                pricing schemes and ensuring your processing rates are optimized.</p>
              <h4>Reducing your credit card processing fees is simple and fast with RateGuard.</h4>
            </div>
          </div>
        </div>
      </div>
      <div className='landing_page3_block8'>
        <div className='landing-container'>
          <div className='landing_page3_block8_subwrapper'>
            <div className='textwrapper'>
              <h2>Aspire Utility Billing Audit</h2>
              <h3>Do you know…</h3>
              <p>ARE YOUR UTILITY BILLS ACCURATE?</p>
              <div className='pborder'></div>
              <p>Utilities are one of the top operating expenses. <span> Many factors impact utility bills,  </span> and errors do occur that are complex and
                difficult to uncover.</p>
              <p>Our utility billing audit is a  zero-risk, hassle-free  process to analyze (and scrutinize) a company’s utility expenses. This in-depth process takes little time on your part with no out-of-pocket expenses.  </p>
              <p><span></span></p>
            </div>
          </div>
        </div>
      </div>
      <div className='landing_page3_block9'>
        <div className='landing-container'>
          <div className='audit_back_wrap '>
            <div className='audit_analyze_wrapper '>
              <div className="audit_analyze_header">
                <h1>What does our Utility billing audit analyze?</h1>
              </div>
              <div className='audit_text_wrap'>
                <h4>Gas, electric, telecom, water, sewer and waste.</h4>

                <div className='audit_text_box'>
                  <h3>What could the Utility billing audit find?</h3>
                  <p>Billing errors, estimated and inaccurate meter readings, tariffs, usage data and  inconsistencies, contract revisions, and many other obscure discrepancies.</p>
                </div>


                <div className='audit_text_box audit_text_box2'>
                  <h3>What’s the Result?</h3>
                  <p> <span className='audit_font'>9</span> out of <span className='audit_font'>10</span> utility billing audit clients save big on utilities,<span className='audit_font'> and may receive utility refunds.</span></p>
                </div>

                <div className='audit_footer'>
                  <h2 className='audit_text6'>ZERO RISK FACTOR</h2>
                  <div className='audit_footer_list'>
                    <div className='audit_footer_list_left'>
                      <ul>
                        <li> No out-of-pocket expense</li>
                        <li> Little company time </li>
                        <li>No risk</li>
                      </ul>
                    </div>

                    <div className='audit_footer_list_right'>
                      <ul>
                        <li>No business interruptions</li>
                        <li>No obligation</li>
                      </ul>
                    </div>
                  </div>
                </div>

              </div>
            </div>
          </div>
        </div>
      </div>


      <div className="landing_page3_block10">
        <div className="landing-container">
          <div className="landing_page3_block10_subwrapper">
            <div className="landing_page3_B10_h1">
              <h1>Why Hire an Auditing firm?</h1>

            </div>
            <div className="landing_page3_block10_textwrapper">
              <p>It’s simple. Daily operations need to run smoothly. Taking time to train employees to monitor utility bills is expensive and impacts the whole company. <span>Disrupt one piece of puzzle</span>, most likely disarray and disorganization are sure to appear in even the strongest of companies.</p>
              <p>An OPERATING COST & EXPENSE REDUCTION REVIEW (utility bill audit) is a review of an organization’s utility invoices including electric, gas, water/sewer, waste, and even telecommunications. This is just the
                beginning of an audit, which may uncover over 30 additional but obscure discrepancies.</p>
              <p>With nearly <span> 15 YEARS of UTILITY and TELECOM AUDITING EXPERIENCE</span>, we specialize in finding hidden expenses with strong utility company relationships. We have successfully helped 90% of clients realize annual savings. <span> As for the other 10% of our clients</span>, they find peace in mind knowing that their business is running as smoothly as possible. </p>
              <p>We are dedicated to clients regardless of savings and will continue to monitor expenses for 36 months to ensure that all adjustments remain in place, while looking for future savings opportunities. </p>
            </div>
          </div>
        </div>
      </div>


      <div className="landing_page3_block11">
        <div className="landing-container">
          <div className="LP3_b11_gradient_bg">
            <div className="LP3_b11_ingBG">
              <img className='bgimg2' src="https://all-frontend-assets.s3.amazonaws.com/aspireLeadFire/landingpage3/LP3_b11_BG_img2.webp" />
              <div className="LP3_b11_padding_wrapper">
                <div className="LP3_b11_gradient_box GB_colors0">
                  <div className="LP3_b11_border_box border_box_color">
                    <div className="LP3_b11_Icon">
                      <img src="https://all-frontend-assets.s3.amazonaws.com/aspireLeadFire/landingpage3/LP3_b11_discoverICON.png" />

                    </div>
                    <h1>DISCOVER</h1>
                    <p>Clients complete a letter
                      of authorization to allow the gathering
                    </p>
                    <div className="line_gradiyent"></div>
                    <p className='GB_paragraph1'>of past invoices, billing history and utility usage.</p>
                  </div>
                </div>


                <div className="LP3_b11_gradient_box GB_colors1">
                  <div className="LP3_b11_border_box">
                    <div className="LP3_b11_Icon">
                      <img src="https://all-frontend-assets.s3.amazonaws.com/aspireLeadFire/landingpage3/LP3_b11_analyzeICON..png" />

                    </div>
                    <h1>ANALYZE</h1>
                    <p>Our experts examine billing data, confirm accuracy and identify
                    </p>
                    <div className="line_gradiyent"></div>
                    <p className='GB_paragraph2'>available savings</p>
                  </div>
                </div>

                <div className="LP3_b11_gradient_box GB_colors2">
                  <div className="LP3_b11_border_box">
                    <div className="LP3_b11_Icon">
                      <img src="https://all-frontend-assets.s3.amazonaws.com/aspireLeadFire/landingpage3/LP3_b11_reportICON..png" />


                    </div>
                    <h1>REPORT</h1>
                    <p>Once analysis is complete. We will provide a
                    </p>
                    <div className="line_gradiyent"></div>
                    <p className='GB_paragraph3'>comprehensive audit report with saving and refund opportunities.</p>
                  </div>
                </div>

                <div className="LP3_b11_gradient_box GB_colors3">
                  <div className="LP3_b11_border_box">
                    <div className="LP3_b11_Icon">
                      <img src="https://all-frontend-assets.s3.amazonaws.com/aspireLeadFire/landingpage3/LP3_b11_saveICON..png" />

                    </div>
                    <h1>SAVE</h1>
                    <p>Savings and refunds are at a client’s discretion. We
                    </p>
                    <div className="line_gradiyent"></div>
                    <p className='GB_paragraph4'>provide 36 months of monitoring to ensure that all adjustments remain in place.</p>
                  </div>
                </div>


              </div>
            </div>
          </div>
        </div>
      </div>






      <div className="landing_page3_block12">
        <div className="landing-container">
          <div className="landing_page3_block12_background">
            <div className="LP3_block12_h1_gradient">
              <h1>ASPIRE WIRELESS</h1>
              <h1>SERVICES AUDIT</h1>
            </div>
            <div className='LP3_block12_text_wrapper'>
              <p>Aspire Wireless Services
                Audit can cut your wireless
                bills <span>up to 50%</span> without
                having to switch carriers,
                phones or numbers
              </p>
            </div>
            <div className="LP3_block12_add">
              <div className="LP3_block12_sub_add2">
                <div className="LP3_block12_sub_add1"><img src="https://all-frontend-assets.s3.amazonaws.com/aspireLeadFire/landingpage3/LP3_block12_add_BG-orange002.png" alt="LP3_block12_add_BG-orange2.png" /></div>

                <div className="LP3_block12_sub_add2_top">
                  <div className="LP3_block12_sub_add2_top_left"><h1>SAVE</h1>
                    <h2>UP TO</h2></div>
                  <div className="LP3_block12_sub_add2_top_right"><h1>50%</h1></div>
                </div>
                <h3>ON YOUR WIRELESS BILLS</h3>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="landing_page3_block13">
        <div className="landing-container">
          <div className="landing_page3_block13_text_wrapper_and_bg">
            <div className="landing_page3_block13_text_wrapper">
              <h1>Step 1: Analysis & Implementation </h1>
              <p>Since 2004, <span>Aspire Wireless service audit</span> has helped customers reduce and better manage their monthly wireless costs. We apply our unmatched industry expertise to customize cost-effective wireless solutions that satisfy your business communication needs, while cutting your spending
                an average 25% or more.
              </p>
              <h2>Use aspire wireless services audit</h2>
              <ul>
                <li><strong>EXCEPTIONAL SAVINGS:</strong> Our customers save an average <span>25% - 33%</span> and more on
                  their wireless plans.
                </li>
                <li>
                  <strong>CREATIVE, CUSTOMIZED SOLUTIONS:</strong> We analyze your wireless spending to the individual user and tailor a cost-effective solution that optimizes your spending.
                </li>
                <li>
                  <strong>UNMATCHED PRICING EXPERTISE:</strong> We conduct a deeper cost analysis, including pricing plans that the carriers don’t make public, to maximize your savings.
                </li>
                <li>
                  <strong>SAVING IS EASY AS 1-2-3:</strong> Just give us your last three month’s wireless bills, and we’ll do the rest. We’ll analyze your current spending, customize a cost-effective solution, and implement all changes with the carriers.
                </li>
                <li>
                  <strong>KEEP YOUR CURRENT PHONE NUMBERS:</strong> We’ll get you a <span>better deal AND let you keep
                    the same carrier</span>, phone numbers and equipment for a truly seamless transition.
                </li>
              </ul>
              <button>START SAVING TODAY</button>
            </div>


          </div>
        </div>
      </div>
      <div className="landing_page3_block14">
        <div className="landing-container">
          <div className="landing_page3_block14_wrapper">
            <div className="landing_page3_block14_text">
              <h1>Step 2: Ongoing Management</h1>
              <p>After a seamless implementation,<span> we will personally scrutinize every charge and variable</span> on your wireless bill on an ongoing basis to minimize spending and help improve your bottom line.</p>
              <p>We can also expertly manage all aspects of your wireless program so you’ll never have to deal with the carriers again. And our fees are based only on the actual savings achieved.</p>
              <div className="landing_page3_block14_sub_wrapper">
                <h2>Value-Added Services</h2>
                <p>We offer a range of value-added services that can save you both time
                  and money, including:</p>
                <ul>
                  <li><strong>DEVICE MANAGEMENT:</strong> We keep an up-to-the-minute inventory of your wireless devices to ensure they’re working properly, secure the best pricing on replacement phones, and use upgrades when possible.
                  </li>
                  <li>
                    <strong>FULFILLMENT:</strong> We can perform the time-consuming task of ordering your wireless devices, handling activations and phone swaps, and look for alternate sources if necessary,<span> with savings up to 50%.</span>
                  </li>
                  <li>
                    <strong>TECHNICAL ASSISTANCE:</strong> We provide first level technical support and work directly with the carriers to quickly resolve more involved technical issues to
                    minimize downtime.

                  </li>
                  <li>
                    <strong>CONSULTING: </strong> We can guide you in selecting the best wireless equipment; for example, <span>whether it’s better for field employees</span> to have a smartphone or a tablet with a basic phone.
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="landing_page3_block15">
        <div className="landing-container">
          <div className="landing_page3_block15_wrapper">
            <div className="h1_wrapper"><h1>Our Promise</h1></div>

            <p>We promise to always act in the customer’s best interest to maximize savings; to
              maintain the knowledge, information and skills necessary to make the best possible recommendations; and to help clients avoid carrying unnecessary phone lines and services by not selling any phone or related service unless we are
            </p>
            <h2>100% certain it is needed and it will not unnecessarily </h2>
            <h2>increase the client’s cost.</h2>

            <img src="https://all-frontend-assets.s3.amazonaws.com/aspireLeadFire/landingpage3/Landing_page3_block15_img1_new.webp" alt="b15_img1" />

          </div>
        </div>
      </div>
      <div className="landing_page3_block16">
        <div className="landing-container">
          <div className="text_wrapper_b16">
            <div className="LP3_b16_top">
              <h1>Workcomp premium recovery group</h1>
              <p>WorkComp Premium Recovery Group specializes in recovering workers’ compensation premium overcharges at no cost to you.<span> We review the past five(5) to seven(7)</span> years insurance policies
                and premium calculations with the goal of locating errors and obtaining refunds for you on a contingency fee basis.</p>
            </div>
            <div className="LP3_b16_bottom">
              <h2>No recovery, No Fee.</h2>
              <h3>Our history has confirmed that<span> 7 out of 10 clients</span> have overpaid their insurance carrier and have received a refund as a result of our review.</h3>
              <div className="LP3_b16_list">
                <ul>
                  <li>Final Audit Billing Statements</li>
                  <li>Experience Rating Worksheet Calculations</li>
                  <li>Policy Declaration Pages</li>
                  <li>Auditor Worksheets</li>
                  <li>Loss History Summaries & Claim Reserves</li>
                  <li>Special Rating Plans</li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="landing_page3_block17">
        <div className="landing-container">
          <div className="LP3_b17_bgimg">
            <div className="LP3_b17_text_wrapper">
              <h1>We guarantee you to receive premium refunds or the peace of mind that you have been charged the correct premiums by your insurance carrier(s). <span>It’s a win/win situation!</span> </h1>
            </div>
          </div>
        </div>
      </div>








    </>
  )
}

export default LandingPage3
